import { type CSSProperties } from 'react'
import { type Attachment } from 'entities/Attachment/model/Attachment'

export const getAttachmentSizeReserve = (attachment?: Attachment): CSSProperties | undefined => {
  if (!attachment?.width || !attachment.height) return undefined

  return {
    width: `${attachment.width}px`,
    aspectRatio: `${attachment.width} / ${attachment.height}`,
  }
}
